import { render } from "./configuration-templates.vue?vue&type=template&id=575b34e4"
import script from "./configuration-templates.vue?vue&type=script&lang=js"
export * from "./configuration-templates.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__